/**
 * @file
 * @prettier
 */

import { InitializeAddLoanPages } from "./AddLoanPages.js";

export function InitializeAddLoanStep3Page() {
  InitializeAddLoanPages();
}
